const statuses = [
    {'value': 'created', 'label': 'Created'},
    {'value': 'processing', 'label': 'Processing'},
    {'value': 'retry', 'label': 'Retry'},
    {'value': 'completed', 'label': 'Completed'},
    {'value': 'failed', 'label': 'Failed'},
    {'value': 'cancelled', 'label': 'Cancelled'}
]

export default statuses
